import { render, staticRenderFns } from "./EventsListItem.vue?vue&type=template&id=58ce6474&"
import script from "./EventsListItem.vue?vue&type=script&lang=js&"
export * from "./EventsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports